<template>
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Materiais Utilizados no Atendimento
      </h3>
      <button
        @click="abrirModalAdicionarMaterial"
        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        <Plus class="w-4 h-4 mr-2" />
        Adicionar Material
      </button>
    </div>

              <!-- Conteúdo Principal -->
     <div v-if="materiaisUtilizados.length > 0">
       <!-- Lista de Materiais Utilizados -->
       <div class="space-y-4 mb-6">
         <div
           v-for="material in materiaisUtilizados"
           :key="material.id"
           class="border border-gray-200 dark:border-gray-700 rounded-lg p-4"
         >
           <div class="flex items-center justify-between">
             <div class="flex-1">
               <h4 class="font-medium text-gray-900 dark:text-white">
                 {{ material.material.nome }}
               </h4>
               <p class="text-sm text-gray-600 dark:text-gray-400">
                 {{ material.material.descricao }}
               </p>
               <div class="mt-2 flex items-center space-x-4 text-sm text-gray-500 dark:text-gray-400">
                 <span>Quantidade: {{ material.quantidade }} {{ material.material.unidade_medida }}</span>
                 <span>Valor Unitário: R$ {{ formatarValor(material.valor_unitario) }}</span>
                 <span class="font-medium text-green-600 dark:text-green-400">
                   Total: R$ {{ formatarValor(material.valor_total) }}
                 </span>
               </div>
               <p v-if="material.observacoes" class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                 Observações: {{ material.observacoes }}
               </p>
             </div>
             <div class="flex items-center space-x-2">
               <button
                 @click="editarMaterial(material)"
                 class="p-2 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
               >
                 <Edit class="w-4 h-4" />
               </button>
               <button
                 @click="removerMaterial(material.id)"
                 class="p-2 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
               >
                 <Trash2 class="w-4 h-4" />
               </button>
             </div>
           </div>
         </div>

         <!-- Resumo -->
         <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
           <div class="flex justify-between items-center">
             <span class="font-medium text-gray-900 dark:text-white">
               Total de Materiais: {{ materiaisUtilizados.length }}
             </span>
             <span class="text-lg font-bold text-green-600 dark:text-green-400">
               Valor Total: R$ {{ formatarValor(valorTotalMateriais) }}
             </span>
           </div>
         </div>
       </div>

       <!-- Observações do Atendimento -->
       <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
         <h4 class="font-medium text-blue-800 dark:text-blue-200 mb-3">Observações do Atendimento</h4>
         <div class="space-y-3">
           <textarea 
             :value="consultationNotes"
             @input="updateNotes"
             placeholder="Adicione observações sobre o atendimento..."
             class="w-full px-4 py-3 border border-blue-200 dark:border-blue-700 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
             rows="4"
           ></textarea>
           <button 
             @click="saveNotes"
             :disabled="isLoading || !consultationNotes.trim()"
             class="w-full px-4 py-3 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
           >
             Salvar Observações
           </button>
         </div>
       </div>
     </div>

     <!-- Estado vazio -->
     <div v-else class="space-y-6">
       <div class="text-center py-8">
         <Package class="w-12 h-12 mx-auto text-gray-400 dark:text-gray-500 mb-4" />
         <p class="text-gray-500 dark:text-gray-400">
           Nenhum material foi utilizado neste atendimento.
         </p>
         <button
           @click="abrirModalAdicionarMaterial"
           class="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-blue-100 hover:bg-blue-200 dark:text-blue-400 dark:bg-blue-900 dark:hover:bg-blue-800"
         >
           <Plus class="w-4 h-4 mr-2" />
           Adicionar Primeiro Material
         </button>
       </div>

       <!-- Observações do Atendimento - Sempre visível -->
       <div class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
         <h4 class="font-medium text-blue-800 dark:text-blue-200 mb-3">Observações do Atendimento</h4>
         <div class="space-y-3">
           <textarea 
             :value="consultationNotes"
             @input="updateNotes"
             placeholder="Adicione observações sobre o atendimento..."
             class="w-full px-4 py-3 border border-blue-200 dark:border-blue-700 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
             rows="4"
           ></textarea>
           <button 
             @click="saveNotes"
             :disabled="isLoading || !consultationNotes.trim()"
             class="w-full px-4 py-3 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
           >
             Salvar Observações
           </button>
         </div>
       </div>
     </div>

    <!-- Modal Adicionar/Editar Material -->
    <div
      v-if="showModalMaterial"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      @click="fecharModalMaterial"
    >
      <div
        class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md mx-4"
        @click.stop
      >
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ editandoMaterial ? 'Editar' : 'Adicionar' }} Material
          </h3>
          <button
            @click="fecharModalMaterial"
            class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X class="w-5 h-5" />
          </button>
        </div>

        <form @submit.prevent="salvarMaterial" class="space-y-6">
          <!-- Seleção do Material -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
              Material Utilizado *
            </label>
            <select
              v-model="formMaterial.material"
              :disabled="editandoMaterial"
              class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-base"
              required
            >
              <option value="">Selecione um material do estoque</option>
              <option
                v-for="material in materiaisEstoque"
                :key="material.id"
                :value="material.id"
              >
                {{ material.nome }} ({{ material.quantidade_estoque }} {{ material.unidade_medida }} disponível)
                <span v-if="material.preco_tabela"> - R$ {{ formatarValor(material.preco_tabela) }}</span>
              </option>
            </select>
            <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
              Selecione o material que foi utilizado durante o atendimento
            </p>
          </div>

          <!-- Observações -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
              Observações (Opcional)
            </label>
            <textarea
              v-model="formMaterial.observacoes"
              rows="3"
              class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-base"
              placeholder="Observações sobre o uso do material (ex: local de aplicação, técnica utilizada, etc.)"
            ></textarea>
            <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
              Informações adicionais sobre como o material foi utilizado
            </p>
          </div>

          <!-- Quantidade -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
              Quantidade Utilizada *
            </label>
            <div class="flex items-center space-x-3">
              <input
                v-model.number="formMaterial.quantidade"
                type="number"
                min="1"
                class="flex-1 px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white text-base"
                required
                placeholder="1"
              />
              <span v-if="materialSelecionado" class="text-sm text-gray-600 dark:text-gray-400 font-medium">
                {{ materialSelecionado.unidade_medida }}
              </span>
            </div>
            <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
              Quantidade do material que foi efetivamente utilizada
            </p>
          </div>

          <!-- Informações do Material Selecionado -->
          <div v-if="materialSelecionado" class="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
            <h4 class="font-medium text-blue-800 dark:text-blue-200 mb-2">Informações do Material</h4>
            <div class="space-y-1 text-sm text-blue-700 dark:text-blue-300">
              <div><span class="font-medium">Nome:</span> {{ materialSelecionado.nome }}</div>
              <div><span class="font-medium">Descrição:</span> {{ materialSelecionado.descricao || 'Não informada' }}</div>
              <div><span class="font-medium">Estoque Disponível:</span> {{ materialSelecionado.quantidade_estoque }} {{ materialSelecionado.unidade_medida }}</div>
              <div><span class="font-medium">Fornecedor:</span> {{ materialSelecionado.fornecedor_padrao?.nome || 'Não definido' }}</div>
              <div v-if="materialSelecionado.preco_tabela" class="text-green-600 dark:text-green-400">
                <span class="font-medium">Preço da Tabela:</span> R$ {{ formatarValor(materialSelecionado.preco_tabela) }}
              </div>
              <div v-else class="text-orange-600 dark:text-orange-400">
                <span class="font-medium">Preço da Tabela:</span> Não configurado (usará valor de compra)
              </div>
            </div>
          </div>

          <!-- Botões -->
          <div class="flex justify-end space-x-3 pt-6 border-t border-gray-200 dark:border-gray-700">
            <button
              type="button"
              @click="fecharModalMaterial"
              class="px-6 py-3 border border-gray-300 dark:border-gray-600 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="loading || !formMaterial.material || !formMaterial.quantidade"
              class="px-6 py-3 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              <Loader2 v-if="loading" class="w-4 h-4 mr-2 animate-spin" />
              {{ editandoMaterial ? 'Atualizar Material' : 'Adicionar Material' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { Plus, Edit, Trash2, X, Package, Loader2 } from 'lucide-vue-next';
import { 
  getMateriaisUtilizados, 
  adicionarMaterialUtilizado, 
  atualizarMaterialUtilizado, 
  removerMaterialUtilizado,
  getMateriaisEstoqueDisponiveis 
} from '@/services/atendimentoService';

export default {
  name: 'MateriaisUtilizados',
  components: {
    Plus,
    Edit,
    Trash2,
    X,
    Package,
    Loader2
  },
  props: {
    scheduleId: {
      type: Number,
      required: true
    },
    appointmentId: {
      type: Number,
      required: true
    },
    consultationNotes: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['material-adicionado', 'material-removido', 'material-atualizado', 'update-notes', 'save-notes'],
  setup(props, { emit }) {
    const materiaisUtilizados = ref([]);
    const materiaisEstoque = ref([]);
    const showModalMaterial = ref(false);
    const editandoMaterial = ref(false);
    const materialEditando = ref(null);
    const loading = ref(false);

    const formMaterial = ref({
      material: '',
      quantidade: 1,
      observacoes: ''
    });

    const materialSelecionado = computed(() => {
      if (!formMaterial.value.material) return null;
      return materiaisEstoque.value.find(m => m.id === formMaterial.value.material);
    });

    const valorTotalMateriais = computed(() => {
      return materiaisUtilizados.value.reduce((total, material) => {
        return total + parseFloat(material.valor_total || 0);
      }, 0);
    });

    const carregarMateriaisUtilizados = async () => {
      try {
        const data = await getMateriaisUtilizados(props.scheduleId, props.appointmentId);
        materiaisUtilizados.value = data;
      } catch (error) {
        console.error('Erro ao carregar materiais utilizados:', error);
      }
    };

    const carregarMateriaisEstoque = async () => {
      try {
        const data = await getMateriaisEstoqueDisponiveis(props.scheduleId, props.appointmentId);
        materiaisEstoque.value = data;
      } catch (error) {
        console.error('Erro ao carregar materiais do estoque:', error);
      }
    };

    const abrirModalAdicionarMaterial = () => {
      editandoMaterial.value = false;
      materialEditando.value = null;
      formMaterial.value = {
        material: '',
        quantidade: 1,
        observacoes: ''
      };
      showModalMaterial.value = true;
    };

    const editarMaterial = (material) => {
      editandoMaterial.value = true;
      materialEditando.value = material;
      formMaterial.value = {
        material: material.material.id,
        quantidade: material.quantidade,
        observacoes: material.observacoes || ''
      };
      showModalMaterial.value = true;
    };

    const fecharModalMaterial = () => {
      showModalMaterial.value = false;
      editandoMaterial.value = false;
      materialEditando.value = null;
    };

    const salvarMaterial = async () => {
      loading.value = true;
      try {
        if (editandoMaterial.value) {
          await atualizarMaterialUtilizado(
            props.scheduleId,
            props.appointmentId,
            materialEditando.value.id,
            {
              quantidade: formMaterial.value.quantidade,
              observacoes: formMaterial.value.observacoes
            }
          );
          emit('material-atualizado');
        } else {
          await adicionarMaterialUtilizado(
            props.scheduleId,
            props.appointmentId,
            formMaterial.value
          );
          emit('material-adicionado');
        }
        
        await carregarMateriaisUtilizados();
        fecharModalMaterial();
      } catch (error) {
        console.error('Erro ao salvar material:', error);
      } finally {
        loading.value = false;
      }
    };

    const removerMaterial = async (materialId) => {
      if (!confirm('Tem certeza que deseja remover este material?')) {
        return;
      }

      try {
        await removerMaterialUtilizado(props.scheduleId, props.appointmentId, materialId);
        await carregarMateriaisUtilizados();
        emit('material-removido');
      } catch (error) {
        console.error('Erro ao remover material:', error);
      }
    };

         const formatarValor = (valor) => {
       return parseFloat(valor || 0).toFixed(2);
     };

     const updateNotes = (event) => {
       emit('update-notes', event.target.value);
     };

     const saveNotes = () => {
       emit('save-notes');
     };

     onMounted(() => {
       carregarMateriaisUtilizados();
       carregarMateriaisEstoque();
     });

         return {
       materiaisUtilizados,
       materiaisEstoque,
       showModalMaterial,
       editandoMaterial,
       formMaterial,
       materialSelecionado,
       loading,
       valorTotalMateriais,
       abrirModalAdicionarMaterial,
       editarMaterial,
       fecharModalMaterial,
       salvarMaterial,
       removerMaterial,
       formatarValor,
       updateNotes,
       saveNotes
     };
  }
};
</script> 